import cx from 'classnames';
import { ButtonHTMLAttributes } from 'react';

import './MinusButton.scss';

function MinusButton({ className, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button {...props} className={cx('MinusButton', className)} type="button" />;
}

export default MinusButton;
